import service from '../../http/axios';

// 获取科研项目列表
export const getImageDataList = service({
  url: '/yinghe-api/imageDataScience/getImageDataList',
});

// 根据类别获取操作过程列表 (团队 个人 公开)
export const getStepsByType = service({
  url: '/yinghe-api/imageDataScience/getStepsByType',
});

// 根据步骤获取操作状态
export const getStatusByStep = service({
  url: '/yinghe-api/imageDataScience/getStatusByStep',
});

//改变数据集步骤和状态
export const changeStepAndStatus = service({
  method: 'POST',
  url: '/yinghe-api/imageDataScience/changeStepAndStatus',
});

// 检查用户是否有操作权限
export const checkAccess = service({
  url: '/yinghe-api/imageDataScience/checkAccess',
});

//启用/停用/删除 0：启用/1：停用/2：删除
export const editImageData = service({
  method: 'POST',
  url: '/yinghe-api/imageDataScience/enable',
});
//封装 导出标注数据
export const exportImageData = service({
  method: 'POST',
  url: '/yinghe-api/imageScienceExportHistory/export',
});

// 获取类别选项
export const getSelectOption = service({
  url: '/yinghe-api/getDicByCode',
});
